import { render } from "./breadcrumb-referee.vue?vue&type=template&id=33d5cf95&scoped=true"
import script from "./breadcrumb-referee.vue?vue&type=script&lang=js"
export * from "./breadcrumb-referee.vue?vue&type=script&lang=js"

import "./breadcrumb-referee.vue?vue&type=style&index=0&id=33d5cf95&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d5cf95"]])

export default __exports__